import React from "react";
import { Input, Label } from "reactstrap";
import { withI18n } from "react-i18next";
import { Link as ReactRouterLink, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import AcceptTerms from "../../components/AcceptTerms";
import ErrorMessage from "../../components/ErrorMessage";
import Button from "common/Button";
import CWBLabsFooter from "common/CWBLabsFooter";
import HorizontalDivider from "common/HorizontalDivider";
import TextInput from "common/TextInput";
import Typography from "common/Typography";
import { getRegisterRedirect } from "../../../../shared/helpers";
const CWBLabsLogin = ({
  t,
  location,
  checkedTerms,
  errors,
  errorMessage,
  isMissingAcceptance,
  rememberMe,
  showFakePassword,
  user,
  onChangeField,
  onCheckTerms,
  onKeyPress,
  onSubmit,
  toggleRememberMe
}) => {
  const regSignup = getRegisterRedirect(location, true);
  
  return (
    <StyledDiv>
      <Card>
        <Typography align="center" component="h1" variant="h3">
          {t("Login to Casting Workbook Labs")}
        </Typography>
        <HorizontalDivider />
        <TextInput
          error={Boolean(errors.workbookId)}
          errorMessage={errors.workbookId}
          label={t("Username or Workbook ID")}
          placeholder={t("Enter Details")}
          value={user.workbookId}
          onChange={(e) => onChangeField("workbookId", e.target.value)}
          onKeyPress={onKeyPress}
        />
        <TextInput
          error={Boolean(errors.password)}
          errorMessage={errors.password}
          label={t("Password")}
          placeholder={t("Enter Details")}
          type="password"
          value={showFakePassword ? "XXXXXXX" : user.password}
          onChange={(e) => onChangeField("password", e.target.value)}
          onKeyPress={onKeyPress}
        />
        <LoginItems>
          <RememberMeContainer>
            <StyledCheckbox
              id="remember-me"
              type="checkbox"
              checked={rememberMe}
              onChange={toggleRememberMe}
            />
            <StyledLabel for="remember-me">
              {t("Remember Me")}
            </StyledLabel>
          </RememberMeContainer>
          <StyledReactRouterLink to={`/login/forgotPwd${location.search}`}>
            {t("I forgot my password")}
          </StyledReactRouterLink>
        </LoginItems>
        {!isMissingAcceptance && (
          <ErrorMessage error={errorMessage}></ErrorMessage>
        )}
        {isMissingAcceptance && (
          <AcceptTerms
            isSelected={checkedTerms}
            onChange={onCheckTerms}
          />
        )}
        <StyledButton id="login-btn" onClick={onSubmit}>
          {t("Login")}
        </StyledButton>
      </Card>
      <SignUpContainer>
        <Typography color="white" variant="bodyBold">
          {t("Don't have an account?")}
        </Typography>
        &nbsp;
        <PrimaryLink href={regSignup}>
          {t("Create one here")}
        </PrimaryLink>
      </SignUpContainer>
      <CWBLabsFooter />
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  width: 100%;
  height: calc(100vh - 80px);
  padding: 10vh 0;
  background-color: #040F1C;

  @media (max-width: 375px) {
    padding: 5vh 0;
  }
`;

const Card = styled.div`
  width: 400px;
  display: flex;
  flex-flow: column nowrap;
  margin: auto;
  padding: 24px 18px;
  background-color: #FFFFFF;
  border-top: 6px solid #02B8F9;
  border-radius: 4px;

  & > label:not(:first-of-type) {
    margin-top: 8px;
  }

  @media (max-width: 375px) {
    width: unset;
    margin: 0 16px;
  }
`;

const LoginItems = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
`;

const RememberMeContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledCheckbox = styled(Input)`
  position: unset;
  margin: 0 8px 0 0;
`;

const StyledLabel = styled(Label)`
  margin: 0;
  font-size: 13px;
`;

const StyledButton = styled(Button)`
  margin-top: 8px;
`;

const PrimaryLink = styled.a`
  color: #02B8F9;
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;
  position: relative;
  top: 2px;
  
  &:hover {
    color: #0892E5;
  }
`;

const SecondaryLink = styled.a`
  color: #364866;
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;

  &:hover {
    color: #364866;
  }
`;

const StyledReactRouterLink = SecondaryLink.withComponent(
  ReactRouterLink
).extend`
  font-size: 13px;
  font-weight: normal;
`;

const SignUpContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  margin-top: 24px;
`;

export default withRouter(withI18n()(CWBLabsLogin));
